.container {
    padding: 24px;
    flex-grow: 1;
    border: 1px solid var(--off-white-dk);
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow-y: auto;
    background-color: var(--white);
}

.submit-button-container {
    display: flex;
    justify-content: flex-end;
}
